import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import type { SpaceType } from "@circle-react/types/Space";

import {
  isChatPostType,
  isCoursePostType,
  isMembersPostType,
} from "../../utils/spaceTypePredicates";
import { ChatNotificationField } from "./ChatNotificationField";
import { PostNotificationField } from "./PostNotificationField";

interface NotificationFieldProps {
  postType: SpaceType;
}

export const NotificationField = ({ postType }: NotificationFieldProps) => {
  const { currentCommunity } = usePunditUserContext();
  const isMobileNotificationsEnabled = Boolean(
    currentCommunity?.ios_app_enabled || currentCommunity?.has_branded_app,
  );

  if (isCoursePostType(postType) || isMembersPostType(postType)) {
    return null;
  }

  if (isChatPostType(postType)) {
    if (!isMobileNotificationsEnabled) {
      return null;
    }
    return <ChatNotificationField />;
  }

  return <PostNotificationField postType={postType} />;
};
